import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        console.log(navigator.maxTouchPoints);
        if (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints >= 1) {
            if (!document.cookie.includes("is_ipados=1")) {
                document.cookie = "is_ipados=1;path=/;max-age=31536000;SameSite=Lax"
            }
        }
    }
}
